import { Request } from '../';

/**
 * 文章信息
 * @param payload
 * @returns {Promise<*>}
 */
export const cmsUser = async payload => {
  const query = `query cmsUser {
  me {
    detail {
      postCount
      createTime
      updateTime
    }
  }
}`;
  return (await Request.request(query, payload, 'cms', '文章信息')).me.detail;
};

/**
 * 根据class获取文章列表
 * @param params
 * @returns {Promise<*>}
 */
export const postListByClass = async params => {
  const gql = `query classAll($query: FormQuery,$query2: FormQuery, $content: ContentQuery) {
    pub {
      classAll(query: $query) {
        data {
          name
          parentName
          index
          nameJson
          createTime
          postList(query: $query2, content: $content){
            data {
              keyword
              pid
              parent
              status
              count
              userInfo {
                isStaff
                userInfo {
                  username
                }
              }
              content {
                title
                subtitle
                summary
                gallery
                pid
                content
              }
            }
            meta {
              page
              count
            }
          }
        }
        meta {
          page
          count
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'cms', '文章列表')).pub.classAll;
  // return request(gql, params, 'cms', '获取文章');
};

/**
 * 我的反馈
 * @param params
 * @returns {Promise<unknown>}
 */
export const feedbackList = async params => {
  const gql = `query class($name: String!, $query: FormQuery, $content: ContentQuery, $queryChildPost: FormQuery) {
    me {
      class(name: $name) {
        name
        postList(query: $query, content: $content) {
          data {
            pid
            createTime
            updateTime
            classes
            numResponse
            content {
              content
              title
              gallery
            }
            childPost(query: $queryChildPost) {
              data {
                pid
                content {
                  content
                  title
                  gallery
                }
              }
            }
          }
          meta {
            limit
            page
            count
            num
          }
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'cms', '我的反馈')).me.class;
};

/**
 * 文章列表
 * @param params
 * @returns {Promise<*>}
 */
export const queryPostList = async params => {
  const gql = `query postList($query: FormQuery, $content: ContentQuery) {
    pub {
      postList(query: $query, content: $content) {
        data {
          pid
          createTime
          content {
            title
            summary
            subtitle
            content
            gallery
          }
        }
        meta {
          limit
          page
          count
        }
      }
    }
  }`;
  return (await Request.request(gql, params, 'cms', '文章列表')).pub.postList;
};

/**
 * 修改文章
 * @param params
 * @returns {Promise<*>}
 */
export const updatePost = async params => {
  const gql = `mutation updatePost($pid: String!, $post: UpdatePost, $content: FormPostContent, $meta: FormPostMeta) {
  meEdit {
    updatePost(pid: $pid, post: $post, content: $content, meta: $meta) {
      pid
      content {
        title
        content
      }
    }
  }
}`;
  return (await Request.request(gql, params, 'cms', '修改文章')).meEdit.updatePost;
};
